export default __webpack_public_path__ + "static/media/vegan-restaurant.11c011a3.png";